
/* 전역 Toast — 접근성(role=status) + KRDS 토큰. 기존 내부 showToast 는 건드리지 않는다 */
(function(){
  window.PIA = window.PIA || {};
  var box=null;
  function ensure(){
    if(box && document.body.contains(box)) return box;
    box=document.createElement('div');
    box.id='pia-toast-box';
    box.setAttribute('role','status');
    box.setAttribute('aria-live','polite');
    document.body.appendChild(box);
    return box;
  }
  PIA.toast=function(msg, ms){
    try{
      var b=ensure();
      var t=document.createElement('div');
      t.className='pia-toast';
      t.textContent=String(msg||'');
      b.appendChild(t);
      setTimeout(function(){
        t.classList.add('pia-toast--out');
        setTimeout(function(){ if(t.parentNode) t.parentNode.removeChild(t); }, 250);
      }, ms||4000);
    }catch(e){ if(window.console) console.error('토스트 표시 실패:', e); }
  };
  if(typeof window.showToast!=='function') window.showToast=PIA.toast;
})();
